const Footer = () => {
  return (
    <div className="uk-text-center uk-padding-large">
      <p>Merry Christmas</p>
      <p>Osmosis Youth, St. Joseph Church</p>
    </div>
  )
}

export default Footer